<template>
  <v-dialog :value="show" max-width="500" @input="(val) => outsideClick(val)">
    <v-card>
      <CloseDialogButton :close="closeAuth" />
      <ResetPassword :to="to" />
    </v-card>
  </v-dialog>
</template>

<script>
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import ResetPassword from "@/components/Auth/ResetPassword/Reset.vue";

export default {
  name: "ResetPasswordDialog",
  components: { CloseDialogButton, ResetPassword },
  data() {
    return {
      valid: true,
    };
  },
  props: {
    closeAuth: Function,
    outsideClick: Function,
    show: Boolean,
    to: Function,
  },
};
</script>
